module.exports = __webpack_public_path__ + "img/b5-3.7f2229c.png";